/* eslint-disable no-invalid-this */
/* eslint-disable new-cap */
import {MobxReactionUpdate} from '@adobe/lit-mobx';
import {LitElement, html, nothing} from 'lit';
import styles from './facet-slider-input.component.scss?as=stylesheet';
import uid from '@mvps-genesis/uid';
import {classMap} from 'lit/directives/class-map.js';
import {createRef, ref} from 'lit/directives/ref.js';
import {defineCustomElement, formatNumber, formatPrice} from 'extensions/utils';

class FacetSliderInput extends MobxReactionUpdate(LitElement) {
	static get styles () {
		return [styles];
	}

	static get properties () {
		return {
			disableFormatOverlay: {
				type: Boolean
			},
			facet: {
				type: String
			},
			focused: {
				type: Boolean
			},
			format: {
				type: String
			},
			label: {
				type: String
			},
			max: {
				type: Number
			},
			min: {
				type: Number
			},
			value: {
				type: Number
			}
		};
	}

	formRef = createRef();

	inputRef = createRef();

	constructor () {
		super();
		this.uid = uid();
		this.value = 0;
		this.max = 999999;
		this.min = 0;
		this.parentForm = this.closest('form');
		this.submitEvent = new Event('submit', {
			bubbles: false,
			cancelable: true
		});
	}

	dispatchFormEvents (shouldSubmit) {
		if (this.formRef.value.checkValidity() === false) {
			if (shouldSubmit) {
				this.formRef?.value?.dispatchEvent(this.submitEvent);
			}
			else {
				this.formRef?.value?.reportValidity();
			}
		}
		else {
			this.parentForm.dispatchEvent(this.submitEvent);
		}
	}

	handleFocus (focused) {
		this.focused = focused;
	}

	handleChange () {
		this.value = parseFloat(this.inputRef?.value?.value);
		this.dispatchFormEvents(true);
	}

	handleSubmit (e) {
		e.preventDefault();

		this.dispatchFormEvents(false);

		return false;
	}

	handleKeyup (e) {
		switch (e.key) {
			case 'Enter':
				this.dispatchFormEvents(true);
				break;
			default:
				break;
		}
	}

	get formattedValue () {
		if (this.facet === 'carat') {
			return parseFloat(this.value)?.toFixed(2);
		}

		return this.value;
	}

	render () {
		const rootClasses = {
			'facet-range-slider--field': true,
			'facet-range-slider--field-active': this.focused
		};

		return html`
			<form ${ref(this.formRef)} class="${classMap(rootClasses)}" @submit="${this.handleSubmit}">
				<label for="${this.uid}" class="facet-range-slider--label">${this.label}</label>
				<div class="input-container">
					<input
						${ref(this.inputRef)}
						id="${this.uid}"
						class="facet-range-slider--value"
						type="number"
						min="${this.min}"
						max="${this.max}"
						step="any"
						required
						.value="${this.formattedValue}"
						@blur="${() => this.handleFocus(false)}"
						@focus="${() => this.handleFocus(true)}"
						@change="${this.handleChange}"
						@keyup="${this.handleKeyup}" />
					${this.disableFormatOverlay ? nothing : html`<input tabindex="-1" aria-hidden="true" ?hidden="${this.focused}" class="facet-input-overlay facet-range-slider--value" value="${this.format === 'currency' ? formatPrice(this.value) : formatNumber(this.value)}">`}
				</div>
				<button type="submit" aria-hidden="true" hidden>Submit</button>
			</form>
		`;
	}
};

defineCustomElement('rb-facet-slider-input', FacetSliderInput);
